/**
 * Token axios instance.
 * Used for refreshing api tokens.
 */

import axios from 'axios';
import { API_URL } from '@/utils/helpers';

export const tokenInstance = axios.create({
  baseURL: API_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});
